import type {
  Copy,
  GroundCancelAmount,
  GroundCancelScenarioV2,
} from "@b2bportal/rbc-ground-cancel-v2-api";

export function getCancelCopy(
  scenario: GroundCancelScenarioV2
): Copy | undefined {
  if ("cancelCopy" in scenario) return scenario.cancelCopy as Copy;
  if ("condition" in scenario)
    return (scenario.condition as { cancelCopy: Copy }).cancelCopy;
  return undefined;
}

/**
 * The refund the backend quoted for this cancellation, when it provided one.
 * For `RefundableWithConditions` the amount lives on the nested `condition`.
 * Returns undefined when the scenario has no quoted amount (the caller should
 * fall back to the amount paid at booking).
 */
export function getRefundAmount(
  scenario: GroundCancelScenarioV2
): GroundCancelAmount | undefined {
  const holder =
    "condition" in scenario
      ? (scenario.condition as { refundAmount?: GroundCancelAmount })
      : (scenario as { refundAmount?: GroundCancelAmount });
  return holder.refundAmount;
}
